import {
    Avatar,
    Box,
    Button,
    Container,
    Link as LinkMui,
    Grid,
    TextField,
    Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { axiosInstancePublic } from "../../services/axios-instance";
import { FORGOT_PASS_URL } from "../../services/endpoints";

function Copyright(props: any) {
    return (
        <Typography
            variant="body2"
            color="text.secondary"
            align="center"
            {...props}
        >
            {"Copyright © "}
            <LinkMui color="inherit" href="https://xgate.io/">
                X-Gate
            </LinkMui>{" "}
            {new Date().getFullYear()}
            {"."}
        </Typography>
    );
}

const ForgotPassword = () => {
    const [emailAddress, setEmailAddress] = useState<string>("");
    const [isEmailCorrect, setIsEmailCorrect] = useState<boolean>(false);
    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        try {
            const responseForgotPassword = await axiosInstancePublic.post(
                FORGOT_PASS_URL,
                {
                    email: emailAddress,
                }
            );
            if (responseForgotPassword.data.success) {
                setIsEmailCorrect(true);
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        let timer: any;
        if (isEmailCorrect) {
            timer = setTimeout(() => {
                setIsEmailCorrect(false);
            }, 4000);
        }
        return () => clearTimeout(timer);
    }, [isEmailCorrect]);

    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    marginTop: 8,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <Avatar
                    src="/logo.svg"
                    // variant="square"
                    alt="logo"
                    sx={{ mb: 0.5 }}
                />
                <Typography component="h1" variant="h5">
                    Reset your password
                </Typography>
                <Box
                    component="form"
                    onSubmit={handleSubmit}
                    noValidate
                    sx={{ mt: 1 }}
                >
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="username"
                        label="Email Address"
                        name="username"
                        autoComplete="username"
                        autoFocus
                        value={emailAddress} // Set the current value of the TextField
                        onChange={(e) => setEmailAddress(e.target.value)} // Update the emailAddress state on change
                        sx={{
                            width: "350px",
                        }}
                    />
                    {isEmailCorrect && (
                        <Typography
                            component="h1"
                            variant="body1"
                            sx={{ mt: 1, color: "green" }}
                        >
                            Password reset instructions will be sent to your
                            registered email address
                        </Typography>
                    )}
                    <Button
                        type="submit"
                        color="warning"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2, width: "350px" }}
                    >
                        Reset
                    </Button>
                    <Grid container>
                        <Grid item>
                            <Link to="/" style={{ textDecoration: "none" }}>
                                <Typography variant="body2" color="primary">
                                    {"Back to the Login page"}
                                </Typography>
                            </Link>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
            <Copyright sx={{ mt: 4, mb: 4 }} />
        </Container>
    );
};

export default ForgotPassword;
